"use client"

import { create } from "zustand"

import { createAudioSlice } from "./slices/audioSlice"
import { createBeatGridSlice } from "./slices/beatGridSlice"
import { createBgVideoSlice } from "./slices/bgVideoSlice"
import { createLyricsSlice } from "./slices/lyricsSlice"
import { createProjectSlice } from "./slices/projectSlice"
import { createScreenSlice } from "./slices/screenSlice"
import { createSettingsSlice } from "./slices/settingsSlice"
import type { AppState } from "./types"

export const useStore = create<AppState>()((...a) => ({
  ...createScreenSlice(...a),
  ...createAudioSlice(...a),
  ...createBgVideoSlice(...a),
  ...createLyricsSlice(...a),
  ...createSettingsSlice(...a),
  ...createProjectSlice(...a),
  ...createBeatGridSlice(...a),
}))

export type { AppState } from "./types"
